import React from 'react';
import PropTypes from 'prop-types';
import compose from '../../../hoc/compose';
import displayNames from '../../displayNames';
import DropDownOption from '../../dropDownOption/dropDownOption';
import TextLabel from '../../textLabel/textLabel';
import RoundedIllustrationContainer from './roundedIllustrationContainer';
var DropDownDetailedOption = function DropDownDetailedOption(props) {
  return /*#__PURE__*/React.createElement(DropDownOption, {
    value: props.value,
    label: props.label,
    className: "dropdown-detailed-option",
    disabled: props.disabled
  }, props.isSelectedElement ? /*#__PURE__*/React.createElement("div", {
    className: "dropdown-detailed-option-label",
    key: "label"
  }, /*#__PURE__*/React.createElement(TextLabel, {
    type: "T03",
    shouldTranslate: props.shouldTranslate,
    value: props.label,
    ellipsisProps: {
      closeOnMouseClick: true
    }
  })) : null, props.icon && !props.isSelectedElement ? /*#__PURE__*/React.createElement("div", {
    className: "dropdown-detailed-option-icon"
  }, /*#__PURE__*/React.createElement(RoundedIllustrationContainer, null, props.icon)) : null, props.isSelectedElement ? null : /*#__PURE__*/React.createElement("div", {
    className: "dropdown-detailed-option-content",
    key: "details"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-detailed-option-title"
  }, /*#__PURE__*/React.createElement(TextLabel, {
    type: "T11",
    shouldTranslate: props.shouldTranslate,
    value: props.label,
    ellipsisProps: {
      closeOnMouseClick: true
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-detailed-option-description"
  }, /*#__PURE__*/React.createElement(TextLabel, {
    type: "T12",
    shouldTranslate: props.shouldTranslate,
    value: props.description,
    ellipsisProps: {
      closeOnMouseClick: true
    }
  }))));
};
DropDownDetailedOption.displayName = displayNames.DROP_DOWN_DETAILED_OPTION;
DropDownDetailedOption.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  wasVisible: PropTypes.bool,
  wasVisibleStyle: PropTypes.object,
  icon: PropTypes.any,
  description: PropTypes.string
};
export default compose(DropDownDetailedOption);